import PrevencaoIcon from '@/components/icons/IndicadoresEsb/Ampliados/Prevencao.vue'

export default {
  value: 'b5',
  label: 'Procedimentos preventivos',
  iconType: 'component',
  iconComponent: PrevencaoIcon,
  buscaAtiva: {},
}
